export default "__VITE_ASSET__CnZIqHRU__"